import "./RichTable.scss";

export default {
  root: "im-rich-table",
  header: "im-rich-table__header",
  dropdowns: "im-rich-table__dropdowns",
};
